/* 推荐线路 */
<template>
  <div id="recommendedLine">


    <div class="flex">
      <div></div>
      <el-button type="primary" @click="addFn">创建</el-button>
    </div>

    <el-table border empty-text="暂无数据" :data="tableData">
      <el-table-column label="展示区域" prop="city"></el-table-column>
      <el-table-column label="展示数量" prop="lineNum"></el-table-column>
      <el-table-column label="备注" prop="remark" v-slot="{row}">{{ row.remark||'-' }}</el-table-column>
      <el-table-column label="操作" width="150" v-slot="{ row }">
        <el-button @click="editClick(row)" type="text" size="small">编辑</el-button>
        <el-button type="text" size="small" @click="removeClick(row)">删除</el-button>
      </el-table-column>
    </el-table>

    <recommendedLineForm :p_visible="visible" :p_id="id" :p_city="city" :p_remark="remark" @closeFn="closeFn" />
  </div>
</template>

<script>
import recommendedLineForm from "./recommendedLineForm";

export default {
  name: "recommendedLine",
  components: { recommendedLineForm },
  data() {
    return {
      tableData: [],
      visible: false,
      id: null, // 编辑城市id
      city: null, // 编辑城市名称
      remark: null, // 编辑城市备注
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    async getTable() {
      let url = "/api/v1/manage/line/recommend/area";
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.tableData = data.data;
      }
    },

    addFn() {
      this.visible = true;
    },

    editClick(row) {
      this.id = row.id;
      this.city = row.city;
      this.remark = row.remark;
      this.visible = true;
    },

    closeFn() {
      [this.id, this.city, this.remark] = [null, null, null];
      this.visible = false;
      this.getTable();
    },

    removeClick(row) {
      this.$confirm(`确定清空${row.city}的推荐线路吗`, "删除提示").then(async () => {
        let data = await this.$axios.delete("/api/v1/manage/line/recommend/area", { id: row.id });
        if (data && data.code === 1) {
          this.$message.success("已删除");
          this.getTable();
        }
      });
    },
  },
};
</script>

<style lang="less">
#recommendedLine {
  .flex {
    margin-bottom: 16px;
    justify-content: space-between;
  }
}
</style>
